import { Clause } from '../api/schemas/schema'
import { t } from '../i18n/i18n'
import { AddItemToCollection, UpdateItemInCollection, RemoveItemFromCollection } from './stateHelper'
import { IDataContext } from '../interfaces/IDataContext'
import { api } from './apiHelper'

export const createClause = async (item: Clause, demandId: string, dataContext: IDataContext): Promise<Clause | null> => {
   try {
      const { accessToken } = dataContext.state
      const clause: Clause = (await api(accessToken).clauseCreate(item, { demandId })).data
      
      AddItemToCollection(dataContext.setRootState, dataContext.state.clauses, clause, 'clauses')

      dataContext.handleMessage(dataContext.setRootState, 'success', t('SavedSuccess'), '')
      return clause
   } catch (error: any) {
      dataContext.handleMessage(dataContext.setRootState, 'error', t('SavedError'), error.message)
      return null
   }
}

export const getClausesByDemandModuleId = async (demandModuleId: string, dataContext: IDataContext) => {
   try {
      const { accessToken } = dataContext.state
      const data = (await api(accessToken).clauseDemandModuleIdDetail(demandModuleId)).data
      const clauses: Clause[] = Array.isArray(data) ? data.filter((c): c is Clause => c !== undefined && c !== null) : []
      return clauses
   } catch (error: any) {
      dataContext.handleMessage(dataContext.setRootState, 'error', t('FetchFailed'), error.message)
      return []
   }
}

export const getClauseById = async (clauseId: string, dataContext: IDataContext): Promise<Clause | null> => {
   try {
      const { accessToken } = dataContext.state
      const data = (await api(accessToken).clauseDetail(clauseId)).data
      return data as Clause
   } catch (error: any) {
      dataContext.handleMessage(dataContext.setRootState, 'error', t('FetchFailed'), error.message)
      return null
   }
}

export const updateClause = async (item: Clause, dataContext: IDataContext) => {
   try {
      const { accessToken } = dataContext.state
      const clause: Clause = (await api(accessToken).clauseUpdate(item)).data

      UpdateItemInCollection(dataContext.setRootState, dataContext.state.clauses, clause, 'clauses')

      dataContext.handleMessage(dataContext.setRootState, 'success', t('SavedSuccess'), '')
      return clause
   } catch (error: any) {
      dataContext.handleMessage(dataContext.setRootState, 'error', t('SavedError'), error.message)
   }
}

export const deleteClause = async (id: string, dataContext: IDataContext) => {
   try {
      const { accessToken } = dataContext.state
      await api(accessToken).clauseDelete(id)

      RemoveItemFromCollection(dataContext.setRootState, dataContext.state.clauses, id, 'clauses')

      dataContext.handleMessage(dataContext.setRootState, 'success', t('ItemDeleted'), '')
   } catch (error: any) {
      dataContext.handleMessage(dataContext.setRootState, 'error', t('DeleteError'), error.message)
   }
}

export const sortClauses = (clauses: Clause[]): Clause[] => {
   return clauses.sort((a, b) => {
      if (a.mainNumber === b.mainNumber) {
         return (a.subNumber ?? 0) - (b.subNumber ?? 0)
      }
      return (a.mainNumber ?? 0) - (b.mainNumber ?? 0)
   })
}
